import ListItemText from '@mui/material/ListItemText';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import FuseNavBadge from '../FuseNavBadge';

const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: 48,
		'&.active': {
			backgroundColor: `${theme.palette.secondary.main} !important`,
			color: `${theme.palette.secondary.contrastText} !important`,
			pointerEvents: 'none',
			'& .nav-list-item-text-primary': {
				color: 'inherit',
			},
			'& .nav-list-item-icon': {
				color: 'inherit',
			},
		},
		'& .nav-list-item-icon': {},
		'& .nav-list-item-text': {
			padding: '0 0 0 16px',
		},
		color: theme.palette.text.primary,
		textDecoration: 'none!important',
	},
}));

const FuseNavHorizontalLink = (props) => {
	// const userRole = useSelector(({ auth }) => auth.user.role);

	const classes = useStyles(props);
	const { item } = props;
	const { t } = useTranslation();

	// const hasPermission = useMemo(() => FuseUtils.hasPermission(item.auth, userRole), [item.auth, userRole]);

	// if (!hasPermission) {
	// 	return null;
	// }

	const IconComponent = item.Icon;

	return (
		<ListItemButton
			component="a"
			href={item.url}
			target={item.target ? item.target : '_blank'}
			className={clsx('nav-list-item', classes.root)}
			role="button"
		>
			<IconComponent className="nav-list-item-icon text-16 flex-shrink-0 scale-150" color="action" />
			<ListItemText
				className="nav-list-item-text"
				primary={item.translate ? t(item.translate) : item.title}
				classes={{ primary: 'text-14 nav-list-item-text-primary' }}
			/>
			{item.badge && <FuseNavBadge className="ml-8" badge={item.badge} />}
		</ListItemButton>
	);
};

FuseNavHorizontalLink.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.string.isRequired,
		title: PropTypes.string,
		icon: PropTypes.string,
		url: PropTypes.string,
		target: PropTypes.string,
	}),
};

const NavHorizontalLink = withRouter(React.memo(FuseNavHorizontalLink));

export default NavHorizontalLink;
